import { useState } from 'react';
import SEO from '../../components/SEO';
import Hero from './components/Hero';
import WhatIsThis from './components/WhatIsThis';
import WhatIncluded from './components/WhatIncluded';
import WhatIsNot from './components/WhatIsNot';
import WhyFree from './components/WhyFree';
import Partnership from './components/Partnership';
import WhoIsFor from './components/WhoIsFor';
import CTA from './components/CTA';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

export default function HomePage() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "行曜科技",
    "description": "提供專業品牌入口建置服務，包含一頁式網站、多頁官網設計、電商開發等解決方案。免費諮詢建置方案，快速打造您的品牌形象網站，提升品牌知名度與客戶轉換率。",
    "url": import.meta.env.VITE_SITE_URL || "https://example.com",
    "provider": {
      "@type": "Organization",
      "name": "行曜科技",
      "description": "專業網站建置服務提供商，致力於為企業打造高品質的品牌入口網站",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com",
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "email": "server@xingyaotech.tw",
        "availableLanguage": ["Chinese"],
        "areaServed": "TW"
      }
    },
    "offers": {
      "@type": "AggregateOffer",
      "offerCount": "3",
      "offers": [
        {
          "@type": "Offer",
          "name": "一頁式網站建置",
          "description": "專業一頁式網站設計，快速建立品牌形象"
        },
        {
          "@type": "Offer",
          "name": "多頁官網設計",
          "description": "完整的企業官網解決方案"
        },
        {
          "@type": "Offer",
          "name": "電商網站開發",
          "description": "功能完善的電商平台建置"
        }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="行曜科技 0 元一頁式網站 | 專業網站建置解決方案"
        description="提供專業品牌入口建置服務，包含一頁式網站、多頁官網設計、電商開發等解決方案。免費諮詢建置方案，快速打造您的品牌形象網站，提升品牌知名度與客戶轉換率。"
        keywords="品牌建置,網站建設,品牌入口,免費建置,專業服務,官網設計,電商開發,SEO優化"
        canonical="/"
        schemaData={schemaData}
      />
      <Hero onOpenForm={() => setIsContactFormOpen(true)} />
      <WhatIsThis />
      <WhatIncluded />
      <WhatIsNot />
      <WhyFree />
      <Partnership />
      <WhoIsFor />
      <CTA onOpenForm={() => setIsContactFormOpen(true)} />
      <Footer onOpenForm={() => setIsContactFormOpen(true)} />
      
      {isContactFormOpen && <ContactForm onClose={() => setIsContactFormOpen(false)} />}
    </div>
  );
}
